import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-card__header"
}
const _hoisted_2 = {
  key: 0,
  class: "ui-card__title"
}
const _hoisted_3 = { class: "ui-card__body" }
const _hoisted_4 = {
  key: 1,
  class: "ui-card__footer"
}

import { computed, useSlots } from "vue";

interface Props {
  title?: string;
  shadow?: "none" | "sm" | "md" | "lg";
  padding?: "none" | "sm" | "md" | "lg";
  hoverable?: boolean;
  bordered?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    title: {},
    shadow: { default: "sm" },
    padding: { default: "md" },
    hoverable: { type: Boolean, default: false },
    bordered: { type: Boolean, default: true }
  },
  setup(__props: any) {

const slots = useSlots();

const props = __props;

const cardClasses = computed(() => {
  const classes = ["ui-card"];
  classes.push(`ui-card--shadow-${props.shadow}`);
  classes.push(`ui-card--padding-${props.padding}`);
  if (props.hoverable) classes.push("ui-card--hoverable");
  if (props.bordered) classes.push("ui-card--bordered");
  return classes;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(cardClasses.value)
  }, [
    (_unref(slots).header || __props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            (__props.title)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(__props.title), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_unref(slots).footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})